import { StaticContentType } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'

export type VideoHeroData = {
  file?: FileEntryBM
  headerText: string
  paragraphText: string
  ctaLink: string
  ctaText: string
  overlayPercentage?: number
}

export const videoHero: StaticContentType<VideoHeroData> = {
  name: 'videoHero',
  viewName: 'Video Hero',
  uuid: '',
  index: 0,
  featureKey: 'componentVideoHero',
  data: {
    headerText: 'Min rubrik',
    paragraphText: 'Min underrubrik',
    ctaLink: '',
    ctaText: '',
    overlayPercentage: 50,
  },
}
